import { Controller } from '@hotwired/stimulus'

// Падел-квиз: показывает вопросы по одному, считает верные ответы на клиенте
// и в конце открывает карточку результата с кнопками шейринга. Состояние
// нигде не сохраняется — квиз можно проходить сколько угодно раз.
export default class QuizController extends Controller {
  static targets = [
    'quiz',
    'question',
    'step',
    'bar',
    'next',
    'result',
    'resultCard',
    'score',
    'shareTg',
    'shareWa',
    'shareX',
    'shareCopy'
  ]

  connect() {
    this.reset()

    // ?result=N открывает сразу карточку результата с таким счётом — по такой
    // ссылке приходят из шейринга. Диапазон — фактическое число вопросов ЭТОГО
    // квиза (this.questionTargets.length), а не хардкод: у разных квизов
    // разное число вопросов. Постороннее значение не совпало бы ни с одной
    // карточкой и оставило бы пустой экран, поэтому такой квиз просто
    // стартует с начала.
    const preview = new URLSearchParams(window.location.search).get('result')
    const max = this.questionTargets.length
    const parsed = Number(preview)
    if (
      preview !== null &&
      /^\d+$/.test(preview) &&
      parsed >= 0 &&
      parsed <= max
    ) {
      this.correct = parsed
      this.showResult()
    }
  }

  select(event) {
    const button = event.currentTarget
    this.selected = button
    const current = this.questionTargets[this.index]
    current.querySelectorAll('.quiz-option').forEach((option) => {
      option.classList.toggle('quiz-option--selected', option === button)
    })
    this.nextTarget.disabled = false
  }

  next() {
    if (!this.selected) return

    if (this.selected.dataset.quizCorrect === '1') this.correct += 1
    this.selected = null
    this.index += 1

    if (this.index >= this.questionTargets.length) {
      this.showResult()
      return
    }

    this.nextTarget.disabled = true
    this.showQuestion()
  }

  restart() {
    this.reset()
  }

  reset() {
    this.index = 0
    this.correct = 0
    this.selected = null
    this.resultTarget.hidden = true
    this.quizTarget.hidden = false
    this.nextTarget.disabled = true
    this.element
      .querySelectorAll('.quiz-option--selected')
      .forEach((option) => option.classList.remove('quiz-option--selected'))
    this.showQuestion()
  }

  showQuestion() {
    this.questionTargets.forEach((question, i) => {
      question.hidden = i !== this.index
    })
    this.stepTarget.textContent = this.index + 1
    this.barTarget.style.width = `${(this.index / this.questionTargets.length) * 100}%`

    const last = this.index === this.questionTargets.length - 1
    const label = this.nextTarget.querySelector('.btn__text')
    if (label) {
      label.textContent = last
        ? this.element.dataset.quizResultLabel
        : this.element.dataset.quizNextLabel
    }
  }

  showResult() {
    this.quizTarget.hidden = true
    this.resultTarget.hidden = false
    this.scoreTargets.forEach((el) => {
      el.textContent = this.correct
    })
    this.resultCardTargets.forEach((card) => {
      const min = Number(card.dataset.min)
      const max = Number(card.dataset.max)
      card.hidden = !(this.correct >= min && this.correct <= max)
    })
    this.applyShareLinks()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  applyShareLinks() {
    // При максимальном счёте — «А ты сможешь повторить?» вместо «лучше?».
    const isMaxScore = this.correct === this.questionTargets.length
    const template =
      (isMaxScore && this.element.dataset.quizShareTextMaxTemplate) ||
      this.element.dataset.quizShareTextTemplate ||
      ''
    const text = template.replace('%{correct}', this.correct)
    // Ссылка с result=N: её OG-превью — карточка результата с подписью
    // padelmesh.com, и она же делает Padelmesh в сообщении кликабельным.
    const url = `${window.location.origin}${window.location.pathname}?result=${this.correct}`
    const encodedText = encodeURIComponent(text)
    const encodedUrl = encodeURIComponent(url)

    // Кнопки лежат в каждой карточке результата — заполняем все копии
    this.shareTgTargets.forEach((a) => {
      a.href = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`
    })
    this.shareWaTargets.forEach((a) => {
      a.href = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`
    })
    this.shareXTargets.forEach((a) => {
      a.href = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`
    })
    this.shareCopyTargets.forEach((button) => {
      button.dataset.copyTextValue = `${text} ${url}`
    })
  }
}
